export const getQuartersString = (quarters: string[]) => {
    if (!quarters || (quarters?.length && quarters.length === 0)) {
        return "";
    }

    return quarters.map((quarter) => getQuarterName(parseInt(quarter))).join(", ");
};

const getQuarterName = (quarters: number) => {
    switch (quarters) {
        case 1:
            return "Wschód";
        case 2:
            return "Zachód";
        case 3:
            return "Północ";
        case 4:
            return "Południe";
        default:
            return "";
    }
};
export const getQuartersString = (quarters: string[]) => {
    if (!quarters || (quarters?.length && quarters.length === 0)) {
        return "";
    }

    return quarters.map((quarter) => getQuarterName(parseInt(quarter))).join(", ");
};

const getQuarterName = (quarters: number) => {
    switch (quarters) {
        case 1:
            return "Wschód";
        case 2:
            return "Zachód";
        case 3:
            return "Północ";
        case 4:
            return "Południe";
        default:
            return "";
    }
};
